import config from '@/config'

import useBackend from '@/hooks/useBackend'

function aussteuerungen() {
  // HOOKS
  const { setup, doPost } = useBackend()

  // INIT
  setup('/ovpv3/public', config.microserviceBaseUrl)

  // METHODS

  function getRiskAssessment(basket) {
    return doPost('/risk-assessment', basket)
  }

  return {
    getRiskAssessment,
  }
}

export default aussteuerungen()
